import MyAds from "../components/ads/MyAdsList";

function MyAdsPage() {
  return (
    <div className="page p-1">
      <MyAds />
    </div>
  );
}

export default MyAdsPage;
